/**
 * 
 * @param {string} name 
 * @returns 
 */

const url = `app`

export const LOAD_ORGANIZATION = `${url}/LOAD_ORGANIZATION`
export const LOAD_ORGANIZATION_SUCCESS = `${url}/LOAD_ORGANIZATION_SUCCESS`
export const LOAD_ORGANIZATION_ERROR = `${url}/LOAD_ORGANIZATION_ERROR`
export const LOAD_USER_ROLE = `${url}/LOAD_USER_ROLE`
export const LOAD_USER_ROLE_SUCCESS = `${url}/LOAD_USER_ROLE_SUCCESS`
export const LOAD_USER_ROLE_ERROR = `${url}/LOAD_USER_ROLE_ERROR`

export const LOAD_USERS = `${url}/LOAD_USERS`
export const LOAD_USERS_SUCCESS = `${url}/LOAD_USERS_SUCCESS`
export const LOAD_USERS_ERROR = `${url}/LOAD_USERS_ERROR`

export const LOAD_TOKEN_EXPIRY = `${url}/LOAD_TOKEN_EXPIRY`
export const LOAD_TOKEN_EXPIRY_SUCCESS = `${url}/LOAD_TOKEN_EXPIRY_SUCCESS`
export const LOAD_TOKEN_EXPIRY_ERROR = `${url}/LOAD_TOKEN_EXPIRY_ERROR`
export const LOAD_USER_ACTIVITIES = `${url}/LOAD_USER_ACTIVITIES`
export const LOAD_USER_ACTIVITIES_SUCCESS = `${url}/LOAD_USER_ACTIVITIES_SUCCESS`
export const LOAD_USER_ACTIVITIES_ERROR = `${url}/LOAD_USER_ACTIVITIES_ERROR`

export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`

export const LOAD_BUSINESS_META_DATA = `${url}/LOAD_BUSINESS_META_DATA`
export const LOAD_BUSINESS_META_DATA_SUCCESS = `${url}/LOAD_BUSINESS_META_DATA_SUCCESS`
export const LOAD_BUSINESS_META_DATA_ERROR = `${url}/LOAD_BUSINESS_META_DATA_ERROR`

export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`


const constants = {
  LOAD_ORGANIZATION,
  LOAD_ORGANIZATION_SUCCESS,
  LOAD_ORGANIZATION_ERROR,
  LOAD_USER_ROLE,
  LOAD_USER_ROLE_SUCCESS,
  LOAD_USER_ROLE_ERROR,
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_ERROR,
  LOAD_TOKEN_EXPIRY,
  LOAD_TOKEN_EXPIRY_SUCCESS,
  LOAD_TOKEN_EXPIRY_ERROR,
  LOAD_USER_ACTIVITIES,
  LOAD_USER_ACTIVITIES_SUCCESS,
  LOAD_USER_ACTIVITIES_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_BUSINESS_META_DATA,
  LOAD_BUSINESS_META_DATA_SUCCESS,
  LOAD_BUSINESS_META_DATA_ERROR,


}

export default constants
